<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div class="w100">
      <div class="row mb-3">
        <div class="col-4">
          <label for="Label" class="form-label">名称</label>
          <input
            type="text"
            class="form-control"
            id="Label"
            placeholder="名称"
            v-model="circuit_obj.label"
          />
        </div>
        <div class="col-4">
          <label for="CircuitCd" class="form-label">サーキットコード</label>
          <input
            type="text"
            class="form-control"
            id="CircuitCd"
            placeholder="サーキットコード"
            v-model="circuit_obj.circuit_cd"
          />
        </div>
        <div class="col-2">
          <label for="Sort" class="form-label">sort</label>
          <input
            type="number"
            class="form-control"
            id="Sort"
            placeholder="ソート"
            v-model="circuit_obj.sort"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-4">
          <label for="Label" class="form-label">略称</label>
          <input
            type="text"
            class="form-control"
            id="Label"
            placeholder="略称"
            v-model="circuit_obj.short_label"
          />
        </div>
        <div class="col-4">
          <label for="CircuitCd" class="form-label">表示名称</label>
          <input
            type="text"
            class="form-control"
            id="CircuitCd"
            placeholder="表示名称"
            v-model="circuit_obj.print_label"
          />
        </div>
        <div class="col-2">
          <label for="Sort" class="form-label">sort</label>
          <input
            type="number"
            class="form-control"
            id="Sort"
            placeholder="ソート"
            v-model="circuit_obj.sort"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <h5>連絡関連</h5>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-6">
          <label for="MailAddress" class="form-label">メールアドレス</label>
          <input
            type="text"
            class="form-control"
            id="MailAddress"
            placeholder="メールアドレス"
            v-model="circuit_obj.mail_address"
          />
        </div>
        <div class="col-3">
          <label for="PassCd" class="form-label">パスコード</label>
          <input
            type="text"
            class="form-control"
            id="PassCd"
            placeholder="パスコード"
            v-model="circuit_obj.pass_cd"
          />
        </div>
        <div class="col-3">
          <label for="ManagerLabel" class="form-label">担当者</label>
          <input
            type="text"
            class="form-control"
            id="ManagerLabel"
            placeholder="担当者"
            v-model="circuit_obj.manager_label"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-8">
          <label for="MailAddress" class="form-label">CCアドレス</label>
          <input
            type="text"
            class="form-control"
            v-model="circuit_obj.cc_mail_address"
          />
        </div>
        <div class="col-4">
          <label for="MailAddress" class="form-label">&nbsp;</label>
          <p class="alert alert-info">
            メインのアドレス以外に転送する場合は「,」半角カンマで区切って指定してください。
          </p>
        </div>
      </div>
      <div class="mb-5"></div>
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-center"
          v-if="chk_relation_type_editable('/master/list')"
        >
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
// import '../../assets/bootstrap/css/sc.css';
import config from '../../../const'

export default {
  name: 'AreaRegionDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: 'サーキットデータ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      circuit_obj: {}
    }
  },
  components: {
    BsPageTitle,
    // BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    async loadCircuitObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(config.BASE_API_URL + '/circuit/lists', params)
        .then(async response => {
          console.log('loadCircuitObj', response)
          this.circuit_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.circuit_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    update() {
      console.log('component methods', this.circuit_obj)
      return this.$store
        .dispatch('updateBasic', {
          data: this.circuit_obj,
          target: 'circuit'
        })
        .then(() => {
          this.alertMessage = this.btnLabel + 'しました'
          this.alertClass = 'alert-success'
        })
        .catch(err => {
          Promise.reject(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          await this.loadCircuitObj()
        })
    },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState({})
  },

  async created() {
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadCircuitObj()
      this.btnLabel = '更新'
    } else {
      this.circuit_obj = {
        id: 0,
        label: '',
        region_cd: '',
        sort: 0
      }
      this.btnLabel = '登録'
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = 'サーキットデータ詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
